"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSortObject = void 0;
const parseSortObject = (obj) => {
    if (!obj)
        return 'id';
    const x = Object.keys(obj).map((key) => {
        const value = obj[key];
        return value < 0 ? `-${key}` : key;
    });
    return x.join(' ');
};
exports.parseSortObject = parseSortObject;
